import React from 'react';
import { Bubble, List } from 'tea-component';
import { getContentDetail } from '@op/utils/languageValue';
import ChannelLabel from '../../ChannelLabel';
import styles from './index.less';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { LanguageType } from '@/pages/opinion/types/common';
/**
 * 渠道小组件
 * @param channel_name 渠道名，后端返回的
 * @param spacing      图标与文字间距
 * @param className
 * @param style
 * @returns
 */
export default function ChatItem({
  item,
  itemClick,
  language = 'origin',
  className = '',
  style,
  iconStyle,
  theme,
  languageMap,
}: {
  item: { [key: string]: any };
  itemClick: () => void;
  language: LanguageType;
  theme?: string;
  className?: string;
  style?: any;
  iconStyle?: any;
  languageMap: {
    origin: string;
    en: string;
    zh: string;
  };
}) {
  const { channel_name, content_url } = item || {};

  return (
    <div className="dbo-context-component">
      <List.Item
        className={`dbo-context-component-flex ${className}`}
        style={style}
      >
        <ChannelLabel
          className={styles['chat-image']}
          showText={false}
          channel_name={channel_name}
        ></ChannelLabel>
        <div
          className={`${styles['chat-list-block']} ${
            theme && styles[theme]
          } dbo-context-component-text`}
          onClick={() => itemClick?.()}
        >
          <span>{getContentDetail(languageMap, language, item)}</span>
        </div>
      </List.Item>
      {content_url && (
        <Bubble content={'Go to source website'} closeOnScroll dark>
          <div
            onClick={(event) => {
              window.open(content_url);
              event.stopPropagation();
            }}
          >
            <SvgIcon
              type="other-share-icon"
              className="dbo-context-component-link"
            />
          </div>
        </Bubble>
      )}
    </div>
  );
}
